module.exports = __webpack_public_path__ + "img/SB.21e850ab.svg";